var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormattedNumber } from 'react-intl';
/** Spread, not `style="percent"`: that prop name trips the lint rule for the DOM `style`. */
var PERCENT = { style: 'percent', maximumFractionDigits: 1 };
/**
 * A share the API sends as 0–100 (`93.8`), formatted by the locale: "93,8 %" in Czech.
 * Written out as `${value} %` it kept the API's decimal point (CZNA-1407).
 */
export var Percent = function (_a) {
    var value = _a.value;
    return React.createElement(FormattedNumber, __assign({ value: value / 100 }, PERCENT));
};
